import { useTranslation } from "react-i18next";
import { MiniHealthCheckQuestion, MiniHealthCheckQuestionOption } from "shared/request/myHealthyAdvantageApi";
import { ModalBody, ModalFooter } from "shared/UI/Modal/Modal";
import Button from "shared/UI/Buttons/Button";

export type MiniHealthCheckQuestionnaireQuestionProps = {
  currentQuestion: MiniHealthCheckQuestion;
  currentOption: MiniHealthCheckQuestionOption | undefined;
  nextButtonText: string;
  onPrevious: VoidFunction;
  onNext: VoidFunction;
  onSelectOption: (option: MiniHealthCheckQuestionOption) => void;
};

export const MiniHealthCheckQuestionnaireQuestion = ({
  currentQuestion,
  currentOption,
  nextButtonText,
  onPrevious,
  onNext,
  onSelectOption,
}: MiniHealthCheckQuestionnaireQuestionProps) => {
  const { t } = useTranslation();

  return (
    <>
      <ModalBody>
        <div className="h-80">
          <h3 className="pb-4">{currentQuestion.title}</h3>
          {currentQuestion.options?.map((option) => {
            return (
              <div key={`option-${option.id}`} className="flex flex-row items-center content-start p-2">
                <input
                  className="h-6"
                  type="radio"
                  name="option"
                  id={`option_${option.id}`}
                  value={option.id}
                  onChange={() => onSelectOption(option)}
                />
                <label htmlFor={`option_${option.id}`} className="pl-2">
                  {option.text}
                </label>
              </div>
            );
          })}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button text={nextButtonText} disabled={currentOption === undefined} onClick={onNext} />
        <Button variant="text" text={t("navigation.previousButton")} onClick={onPrevious} />
      </ModalFooter>
    </>
  );
};
